import { NgModule } from '@angular/core';
import { FilterIngPipe } from '@app/pipes/filterIng/filterIng.pipe';
import { PlusPipe } from '@app/pipes/plus/plus.pipe';
import { ToArrPipe } from '@app/pipes/toArray/toArray.pipe';
import { SafeHtmlPipe } from './safe-html/safe-html.pipe';
@NgModule({
    imports: [
    ],
    declarations: [
        PlusPipe,
        FilterIngPipe,
        ToArrPipe,
        SafeHtmlPipe
    ],
    exports: [
        PlusPipe,
        FilterIngPipe,
        ToArrPipe,
        SafeHtmlPipe
    ]
})

export class PipesModule {

}
